// Helper to convert data to booked by
export default function convertToBookedBy({ postData, values }) {
  // Start with original data.
  // For now we only use postData.vaccination, the others are overwritten to only contain what is needed for booked_by bookings
  const bookedByPostData = { ...postData }

  // Swap person data so the one having the vaccination is registered as the person
  bookedByPostData.person = {
    first_name: values.details.on_behalf_of.first_name,
    last_name: values.details.on_behalf_of.last_name,
    national_id: values.details.on_behalf_of.national_id,
    phone: values.person?.phone,
  }

  bookedByPostData.booking_details = {
    slot_id: values.slot_id,
    // Note: No need to pass national_id + name in "booked_by". That is automatically added in the backend, based on the logged in user
    booked_by: {
      relation: values.details.on_behalf_of?.relation,
      phone: values.person?.phone,
    },
  }

  return bookedByPostData
}
